module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../node_modules/happypack/loader.js?id=jsx!./ExpertCardView.js"));
	}, "ExpertCardView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=ExpertCardView!./src/pages/Share/ExpertCard/ExpertCardView.js
// module id = 1197
// module chunks = 431